import toast from "react-hot-toast";

export const useCopyToClipboard = () => {
  return {
    onCopy: (value) => {
      navigator.clipboard.writeText(value);
      toast.success("Copied to clipboard");
    }
  }
}